// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html,
body {
  font-size: 14px;
}

:root {
  --el-form-label-font-size: 14px;
}

.flex {
  display: flex;
}

.flex-c {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-vc {
  display: flex;
  align-items: center;
}

.flex-hc {
  display: flex;
  justify-content: center;
}

.text-over-hidden {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.split-line {
  width: 100%;
  height: 1px;
  background-color: #b0d5f9;
  margin: 20px 0px;
  display: block;
}

.tk-btn {
  text-align: center;
  padding: 8px 10px;
  background: linear-gradient(315deg, #6772FF 0, #00F9E5 100%);
  color: #fff;
  border-radius: 4px;
}
.tk-btn:active {
  background: #fcdd52;
}
.tk-btn i {
  margin-right: 5px;
}

.hz-message-box.el-message-box .el-button {
  width: 84px;
}

.hz-footer-button-box {
  width: 100%;
  min-width: 300px;
  display: flex;
  justify-content: center;
}
.hz-footer-button-box .el-button {
  width: 84px;
}

.search-form.el-form {
  padding: 0;
  padding-bottom: 0px;
  margin-bottom: 10px;
}
.search-form.el-form > * {
  display: inline-flex;
  vertical-align: middle;
}
.search-form.el-form .el-form-item {
  margin-bottom: 12px;
  margin-right: 24px;
}
.search-form.el-form .el-form-item .el-form-item__content {
  width: 200px;
}

#app ~ div .el-table, #app .el-table {
  color: rgba(0, 0, 0, 0.65);
}
#app ~ div .el-table.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell, #app .el-table.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #ddf8fe;
}
#app ~ div .el-table thead, #app .el-table thead {
  color: #000;
}
#app ~ div .el-table thead th, #app .el-table thead th {
  font-weight: 500;
}
#app ~ div .el-table thead th.el-table__cell, #app .el-table thead th.el-table__cell {
  background-color: rgb(214, 236, 251);
}
#app ~ div .el-table .el-table__cell, #app .el-table .el-table__cell {
  padding: 10px 0px;
}
#app ~ div .el-button:not(.is-link), #app .el-button:not(.is-link) {
  padding: 8px 24px;
}

.el-form .el-select, .el-form .el-input {
  width: 200px;
}

.fixed-label-width .el-form-item__label {
  width: 100px;
}

.el-input.el-input-money .el-input__wrapper {
  padding: 0px 5px;
}
.el-input.el-input-money .el-input__inner {
  height: 26px;
  line-height: 26px;
}

.hx-pagination-box {
  margin-top: 20px;
}

.dialog-footer.my-dialog-foot {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}

.search-btn-block > button {
  margin-bottom: 12px;
  margin-right: 12px;
}
.search-btn-block .el-button + .el-button {
  margin-left: 0px;
}

.my-dialog-form .el-form-item {
  display: flex;
  justify-content: center;
}
.my-dialog-form .el-form-item .el-form-item__content {
  flex: unset;
}

.el-dialog__header {
  margin-right: 0px !important;
  border-bottom: 1px solid #b3cbf7;
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-thumb {
  /*// 滑块颜色*/
  background: #ccc;
  border-radius: 5px;
}

/* // 兼容Firefox、IE */
* {
  scrollbar-width: 10px;
  scrollbar-base-color: green;
  scrollbar-track-color: red;
  scrollbar-arrow-color: blue;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
